import { render } from "./KycConditions.vue?vue&type=template&id=3ee8264a"
import script from "./KycConditions.vue?vue&type=script&lang=js"
export * from "./KycConditions.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__